import { Component, OnInit, Input } from '@angular/core';
import { FormLabel } from '../../interfaces/form-label';

@Component({
  selector: 'cargoes-form-label',
  template: ` <ng-container
    *ngIf="labelName && labelName.labels && labelName.labels.length >= 0"
  >
    <nz-form-label [nzRequired]="fieldValidation()" class="labelTxt">
      <span [translate]="labelName.labels[labelIndex]"></span>
      <i
        nz-icon
        nzType="question-circle"
        nz-tooltip
        nzTheme="outline"
        [nzTooltipTitle]="defaultData"
        class="tooltip"
      ></i>
      <span class="idSpan" *ngIf="withUid">{{ labelName.uid }}</span>
    </nz-form-label>
    <ng-template #defaultData>
      <span *ngIf="labelName.tooltip">{{ labelName.tooltip | translate }}</span>
      <span *ngIf="!labelName.tooltip">{{
        labelName.labels[labelIndex] | translate
      }}</span>
    </ng-template>
  </ng-container>`,
})
export class FormLabelComponent implements OnInit {
  withUid = false;

  @Input() public labelName!: FormLabel;
  @Input() public labelIndex = 0;
  @Input() public isMandatory!: boolean;

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  fieldValidation() {
    if (this.isMandatory === null || this.isMandatory === undefined) {
      return this.labelName['mandatory'] ? this.labelName['mandatory'] : false;
    } else {
      return this.isMandatory;
    }
  }
}
